import { render, staticRenderFns } from "./recycle-manage.vue?vue&type=template&id=47286e27"
import script from "./recycle-manage.vue?vue&type=script&lang=ts"
export * from "./recycle-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports